import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const usePlans = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    api.get("/public/plans")
      .then((r) => setPlans(r.data || []))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);
  return { plans, loading, error };
};

export const useSiteUrl = () => {
  const [site, setSite] = useState(window.location.origin);
  useEffect(() => {
    api.get("/public/config").then((r) => {
      const s = (r.data?.site_url || "").replace(/\/$/, "");
      if (s) setSite(/^https?:\/\//.test(s) ? s : `https://${s}`);
    }).catch(() => {});
  }, []);
  return site;
};
